import React, { Fragment, useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import { RootState } from '../../../../store/store';
import { useLanguage } from '../../../../context/LanguageProvider';
import { NepNowDateFormat } from '../../../../constants/DateFormat';
import AppURL from '../../../../constants/AppURL';
import { formatMoney_2, NumberToNepaliNum } from '../../../../helpers/DateFormat';

interface TrialRptPrintProps {
  onTrialReport: any;
}
const PrintTrialRptView: React.FC<TrialRptPrintProps> = ({ onTrialReport }) => {
  const { SOFTWARE_ORG, ACCOUNT_RPT_DATE } = useSelector((state: RootState) => state.software);
  const org_details = SOFTWARE_ORG?.org;
  const date_report = ACCOUNT_RPT_DATE.acc_rpt;
  const { language } = useLanguage();
  const [totalAmt, setOnTotalAmt] = useState({ totalDRAmt: 0, totalCRYear: 0 })
  useEffect(() => {
    if (onTrialReport?.results) {
      const totalDrAmount = onTrialReport.results.reduce((total: any, voucher: any) => {
        return total + (voucher.curyear_dr || 0);
      }, 0);

      const totalCRAmount = onTrialReport.results.reduce((total: any, voucher: any) => {
        return total + (voucher.curyear_cr || 0);
      }, 0);

      setOnTotalAmt({ totalDRAmt: totalDrAmount, totalCRYear: totalCRAmount });
    }
  }, [onTrialReport]);

  const DateNow = NepNowDateFormat();
  return (
    <Fragment>
      <style>
        {`@media print {
            @page {
            size: A4 landscape;
            page-break-before: always;
            margin: 0.5in; 
            border: 1px solid black;
         }
        }`}
      </style>
      <div className='bg-white h-screen'>
        <div className="relative border border-gray-300 p-0.5">
          <table className="w-full text-sm text-left rtl:text-right text-black">
            <tbody>
              <tr>
                <td className={`w-[25%] text-[12px] text-black whitespace-nowrap ${language === "Eng" ? "font-public-sans" : "font-nepali"}`} >
                  {language === "Eng" ? "S. Code: " : "एस. कोड:"}:  {language === "Eng" ? org_details?.org_reg : NumberToNepaliNum(org_details?.org_reg || "")}
                </td>
                <td className="w-[25%]">
                </td>
                <td className="w-[25%]">
                </td>
                <td align='right' className={`w-[25%] text-[12px] text-black whitespace-nowrap ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                  {language === "Eng" ? "Phone: " : "फोन नम्बर:"}  {language === "Eng" ? org_details?.org_phone : NumberToNepaliNum(org_details?.org_phone || 0)}
                </td>
              </tr>
              <tr >
                <td rowSpan={4} className="w-[25%] font-medium text-black whitespace-nowrap dark:text-white">
                  <img width={60} height={60} src={AppURL.BaseURL + org_details?.logo} alt="" />
                </td>
                <td align='center' colSpan={2} className={`w-[25%] text-black font-bold text-[18px] ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                  {language === "Eng" ? org_details?.org_name : org_details?.org_name_nep}
                </td>
                <td className="w-[25%]">
                </td>
              </tr>
              <tr >
                <td align='center' colSpan={2} className={`w-[25%] text-black font-normal text-[12px] ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                  {language === "Eng" ? org_details?.org_add : org_details?.org_add_nep}
                </td>
                <td align='right' className={`w-[25%] text-[11px] text-black font-normal ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                  {language === "Eng" ? "Date: " : "मिति: "} {language === "Eng" ? DateNow : NumberToNepaliNum(DateNow)}
                </td>
              </tr>
              <tr >
                <td align='center' colSpan={2} className={`w-[25%] underline text-black text-[15px] ${language === "Eng" ? "font-public-sans font-medium" : "font-nepali font-thin"}`}>
                  {language === "Eng" ? "Trial Report" : "परीक्षण रिपोर्ट"}
                </td>
                <td className="w-[25%]">
                </td>
              </tr>
              <tr>
                <td align='center' colSpan={2} className={`w-[25%] text-black font-light text-[11px] ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                  {language === "Eng" ? "Date: " : "मिति: "}
                  {date_report?.date_from} {language === "Eng" ? "from " : "बाट "} {date_report?.date_to} {language === "Eng" ? "Upto " : "सम्म"}
                </td>
                <td align='right' className="w-[25%] text-[11px]">
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div className={`relative`}>
          <table className="w-full text-left rtl:text-right text-black ">
            <thead className="text-[11px]  font-light text-gray700 bg-slate-100 dark:bg-sky-950 capitalize border-b dark:bg-slate900 dark:text-slate-400">
              <tr>
                <th scope="col" align='center' className={`px-1 border border-slate-300 dark:border-sky-800 w-10 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                  {language === "Eng" ? "S.N." : "स.नं."}
                </th>
                <th scope="col" align='center' className={`px-1 border border-slate-300 dark:border-sky-800 w-10 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                  {language === "Eng" ? "GLID" : "भौ.कोड."}
                </th>
                <th scope="col" align='center' className={`px-1 border border-slate-300 dark:border-sky-800 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                  {language === "Eng" ? "Particulars" : "विवरण"}
                </th>
                <th scope="col" align='center' className={`px-1 border border-slate-300 dark:border-sky-800 w-[25%] ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                  {language === "Eng" ? "Debit Amount" : "डेबिट रकम"}
                </th>
                <th scope="col" align='center' className={`px-1 border border-slate-300 dark:border-sky-800 w-[25%] ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                  {language === "Eng" ? "Credit Amount" : "क्रेडिट रकम"}
                </th>
              </tr>

            </thead>
            <tbody className={`text-slate-800 text-[11px] ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
              {Array.isArray(onTrialReport?.results) &&
                onTrialReport?.results?.map((ledger: any, index: number) =>
                (
                  <tr key={index}>
                    <td align='center' className={`px-1 border border-gray-300 font-normal dark:border-sky-800 capitalize ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                      {language === "Eng" ? index + 1 : NumberToNepaliNum(index + 1)}.
                    </td>
                    <td align='left' className={`px-1 border border-gray-300 font-normal dark:border-sky-800 capitalize ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                      {`${ledger?.subledgerid === null ? language === "Eng" ? ledger?.glid : NumberToNepaliNum(ledger?.glid) : language === "Eng" ? ledger?.subledgerid : NumberToNepaliNum(ledger?.subledgerid || "")}`}
                    </td>
                    <td align='left' className={`px-1 border border-gray-300 dark:border-sky-800 capitalize`}>
                      <span className={`font-bold ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>{ledger?.subledgerid === null ? language === "Eng" ? ledger?.glname : ledger?.glnamenep : ""}</span>{ledger?.subamt ? <div className='flex justify-between'><span className='pl-9 font-normal'>{ledger?.sub_ledg_id !== 0 ? language === "Eng" ? ledger?.subledgname : ledger?.subledgnamenep : ""}</span><span className={`pl-8 font-normal ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>{ledger?.subamt ? formatMoney_2(ledger?.subamt) : formatMoney_2(0)}</span></div> : ""}
                    </td>
                    <td align='right' className={`px-1 border border-gray-300 font-normal dark:border-sky-800 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                      {language === "Eng" ? formatMoney_2(ledger?.curyear_dr || 0) : NumberToNepaliNum(formatMoney_2(ledger?.curyear_dr || 0))}
                    </td>
                    <td align='right' className={`px-1 border border-gray-300 font-normal dark:border-sky-800 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                      {language === "Eng" ? formatMoney_2(ledger?.curyear_cr || 0) : NumberToNepaliNum(formatMoney_2(ledger?.curyear_cr || 0))}
                    </td>
                  </tr>
                )
                )
              }
              <tr className='text-[11px] text-black bg-gray100'>
                <td align='right' colSpan={2} className={`px-1 font-bold border border-gray-300 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                  {language === "Eng" ? "Total Amount" : "कुल रकम"}
                </td>
                <td align='right' colSpan={1} className={`px-1 font-bold border border-gray-300 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                  {language === "Eng" ? formatMoney_2(totalAmt?.totalDRAmt || 0) : NumberToNepaliNum(formatMoney_2(totalAmt?.totalDRAmt || 0))}
                </td>
                <td align='right' colSpan={1} className={`px-1 font-bold border border-gray-300 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                  {language === "Eng" ? formatMoney_2(totalAmt?.totalCRYear || 0) : NumberToNepaliNum(formatMoney_2(totalAmt?.totalCRYear || 0))}
                </td>
                <td align='right' colSpan={1} className={`px-1 font-bold border border-gray-300 ${language === "Eng" ? "font-public-sans" : "font-nepali"}`}>
                  {language === "Eng" ? formatMoney_2(totalAmt?.totalCRYear || 0) : NumberToNepaliNum(formatMoney_2(totalAmt?.totalCRYear || 0))}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <br />
      </div >
    </Fragment>

  )
}

export default PrintTrialRptView

